/** 新增实验不要使用此枚举，请使用ABResEnum */
export enum ExperimentResEnum {
    /** 对照组 */
    ORIGIN = '1',
    /** 实验组 */
    EXPERIMENT = '0',
    /** 默认状态 */
    DEFAULT = '-1',
}

/**
 * ab实验结果枚举（与新项目保持一致）
 * ab测试的值需规范化（实验组设为1、对照组值为0）
 */
export enum ABResEnum {
    /** 命中实验：实验组 */
    HINT = '1',
    /** 命中实验：实验组2 */
    HINT2 = '2',
    /** 命中实验：实验组3 */
    HINT3 = '3',
    /** 未命中实验：对照组 */
    WAITHINT = '0',
    /** 默认状态 */
    DEFAULT = '-1'
}
